import { BaseResponse } from './base.response';
import { State } from '../models';

export class StatesResponse extends BaseResponse {

  public states: State[];

}
